module.exports = __webpack_public_path__ + "static/media/mpg.c64387e6.jpg";